<template>
  <div
    class="dx-tooltip-warpper"
    :class="`trigger-${trigger} position-${position}`"
  >
    <!-- 在顶层通过传入的visible进行控制 -->
    <transition>
      <div v-show="visible !== undefined ? visible : true" class="dx-tooltip-max-width">
        <!-- 在内层通过组件自身的tooltipvisible进行控制 -->
        <div
          class="dx-tooltip-content-warpper"
          :style="
            background ? { background, color: '#fff', borderColor: background, width } : { width }
          "
        >
          <div class="tooltip-title">
            {{ title }}
          </div>
          <div
            class="tooltip-icon"
            :style="background ? { background, color: '#fff', borderColor: background } : {}"
          />
        </div>
      </div>
    </transition>
    <slot />
  </div>
</template>

<script>

export default {
  props: {
    // tooltip的内容
    title: {
      required: false,
      default: '',
      type: String
    },
    // tooltip的触发方式 hover click
    trigger: {
      required: false,
      default: 'hover',
      type: String
    },
    // 可以用来手动控制tooltip的出现或者消失
    visible: {
      required: false,
      default: undefined,
      type: Boolean
    },
    // tooltip出现的位置
    position: {
      required: false,
      default: 'topLeft',
      type: String
    },
    // 可以设置tooltip的背景颜色
    background: {
      required: false,
      default: '',
      type: String
    },
    // 自定义tooltip的宽度,tooltip的宽度受被包裹元素的影响，这里提供自定义
    width: {
      required: false,
      default: '',
      type: String
    }
  },
}
</script>

<style lang="less" scoped>

.dx-tooltip-warpper {
  display: inline-block;
  position: relative;
  cursor: pointer;

  .dx-tooltip-max-width {
    text-align: initial;
    position: absolute;
    z-index: 0;
    width: 100%;
    left: -70px;
    top: -8px;
  }

  .dx-tooltip-content-warpper {
    display: inline-block;
    text-align: initial;
    padding: 6px 10px;
    background: rgba(0, 0, 0, 0.75);
    border: rgba(0, 0, 0, 0.75);;
    border-radius: 2px;
    min-width: 200px;
  }

  .tooltip-title {
    font-size: 14px;
    z-index: 1000;
    color: #fff;
    line-height: normal;
  }

  .tooltip-icon {
    position: absolute;
    z-index: 999;
    width: 0px;
    height: 0px;
    border-top: 6px solid rgba(0, 0, 0, 0.75);
    border-left: 6px solid transparent;
    border-right: 6px solid transparent;
    margin-top: 6px;
    margin-left: 65px;
    // width: 12px;
    // height: 12px;
    // transform: rotate(45deg);
    // background: rgba(0, 0, 0, 0.75);;
    // border-bottom: rgba(0, 0, 0, 0.75);;
    // border-right: rgba(0, 0, 0, 0.75);;
  }
}

.dx-tooltip-warpper.position-topLeft {
  .dx-tooltip-content-warpper {
    position: absolute;
    bottom: calc(100% + 10px);
  }
}

.dx-tooltip-warpper.position-top {
  .dx-tooltip-max-width {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
  }
  .dx-tooltip-content-warpper {
    position: absolute;
    bottom: calc(100% + 10px);
    left: 50%;
    transform: translateX(-50%);
  }

  .tooltip-icon {
    position: absolute;
    left: 50%;
    margin-left: -4px;
  }
}

.dx-tooltip-warpper.position-topRight {
  .dx-tooltip-max-width {
    position: absolute;
    right: 0;
  }

  .dx-tooltip-content-warpper {
    position: absolute;
    right: 0;
    bottom: calc(100% + 10px);
  }

  .tooltip-icon {
    position: absolute;
    right: 12px;
  }
}

.dx-tooltip-warpper.position-bottomLeft {
  .dx-tooltip-max-width {
    position: absolute;
    bottom: -10px;
  }

  .dx-tooltip-content-warpper {
    position: absolute;
  }

  .tooltip-icon {
    position: absolute;
    top: -6px;
    transform: rotate(-135deg);
  }
}

.dx-tooltip-warpper.position-bottom {
  .dx-tooltip-max-width {
    position: absolute;
    bottom: -10px;
    left: 50%;
    transform: translateX(-50%);
  }
  .dx-tooltip-content-warpper {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
  }

  .tooltip-icon {
    position: absolute;
    top: -6px;
    left: 50%;
    margin-left: -4px;
    transform: rotate(-135deg);
  }
}

.dx-tooltip-warpper.position-bottomRight {
  .dx-tooltip-max-width {
    position: absolute;
    bottom: -10px;
    right: 0;
  }

  .dx-tooltip-content-warpper {
    position: absolute;
    right: 0;
  }

  .tooltip-icon {
    position: absolute;
    top: -6px;
    right: 12px;
    transform: rotate(-135deg);
  }
}

.dx-tooltip-warpper.position-left {
  .dx-tooltip-max-width {
    position: absolute;
    top: 50%;
  }

  .dx-tooltip-content-warpper {
    position: absolute;
    transform: translateX(-100%) translateY(-50%);
    left: -10px;
  }

  .tooltip-icon {
    position: absolute;
    right: -6px;
    top: calc(50% - 6px);
    transform: rotate(-45deg);
  }
}

.dx-tooltip-warpper.position-right {
  .dx-tooltip-max-width {
    position: absolute;
    top: 50%;
    margin-left: calc(100% + 10px);
  }

  .dx-tooltip-content-warpper {
    position: absolute;
    transform: translateY(-50%);
  }

  .tooltip-icon {
    position: absolute;
    left: -6px;
    top: calc(50% - 6px);
    transform: rotate(135deg);
  }
}
</style>


// WEBPACK FOOTER //
// CommonTooltipInner.vue?8be794a6